import React, { Component } from "react";
import * as Http from "../../../http";
import { ProgressBar } from "react-bootstrap";
import * as Business from "../../../utils/business";
import { ErrorCode, URL as ApiURL } from "../../../const";
import { Field, reduxForm } from "redux-form";

import MessageBox from "../../../components/MessageBox";
import UploadSelectedFilesPanel from "../../../components/UploadSelectedFilesPanel";
import { FileExtension } from "../../../const";
import { v4 as uuidv4 } from "uuid";
import moment from "moment";
import Options from "./Options";

const chunkSize = 1048576 * 3;
let lstInterval = [];

function clearGetBatchUploadInterval(reportName) {
  lstInterval.forEach((id) => {
    clearInterval(id);
    console.warn(`${reportName} | Received state: STOP`);
  });
}

function convertReportName(reportName) {
  return `RAROC_${reportName}`;
}

function buildValidatePageUrl(reportDate, reportName) {
  const token = Http.getToken() || "";
  const params = new URLSearchParams({
    apiBase: ApiURL.fileV2,
    token,
    reportDate,
    reportName,
    component: "RAROC",
  });
  return `/validate-result?${params.toString()}`;
}

class UploadFile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      progressValue: 0,
      errorCode: null,

      lstErrUpload: [],
      isShowMessageBox: false,

      singleConsol: "single",
      fileExtension: FileExtension.XLSX,
      isMultipleFile: false,
      fileAccept:
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel",
      reportName: "",
      reportDate: null,
      noFileVal: "No file chosen...",
      classFileUpload: "file-upload",
      isDragging: false,

      totalFiles: 0,
      listFileNameSelected: [],
      dicFileToBeUpload: {},
      isUploadOnly: false,
      isUploadAndMerge: false,
      isCalculateOnly: false,
      isUploadOnlySuccessful: false,
      isUploadAndMergeSuccessful: false,
      validatePageUrl: null,

      option: "option1",
      currentStep: "form",
      sseErrors: [],
      ssePercent: 0,
      sseDone: false,
      sseStarted: false,
      uploadErrors: [],
      autoNavCountdown: null,
    };
    this.setFileExtensionSelected = this.setFileExtensionSelected.bind(this);
    this.onChangeFile = this.onChangeFile.bind(this);
    this.onUploadFile = this.onUploadFile.bind(this);
    this.onUploadFileAndMergeData = this.onUploadFileAndMergeData.bind(this);
    this.onUploadChunkFile = this.onUploadChunkFile.bind(this);
    this.onUploadChunkFileComplete = this.onUploadChunkFileComplete.bind(this);
    this.onGetBatchUploadingResponse =
      this.onGetBatchUploadingResponse.bind(this);
    this.onShowMessageBox = this.onShowMessageBox.bind(this);

    this.handleUploadFileResponse = this.handleUploadFileResponse.bind(this);
    this.renderProgress = this.renderProgress.bind(this);
    this.renderUploadOnlySuccessful =
      this.renderUploadOnlySuccessful.bind(this);
  }

  _autoNavTimer = null;

  componentDidUpdate(prevProps, prevState) {
    if (
      !prevState.hasResult &&
      this.state.hasResult &&
      this.state.validatePageUrl
    ) {
      this._startAutoNav();
    }
  }

  componentWillUnmount() {
    if (this._autoNavTimer) {
      clearTimeout(this._autoNavTimer);
    }
  }

  _startAutoNav = () => {
    let count = 3;
    const tick = () => {
      if (count <= 0) {
        this.props.history.push(this.state.validatePageUrl);
        return;
      }
      this.setState({ autoNavCountdown: count });
      count -= 1;
      this._autoNavTimer = setTimeout(tick, 1000);
    };
    tick();
  };

  onChangeFile = (e) => {
    const target = e.target;
    const filename = target ? target.value : "";
    let classFileUpload = "file-upload";
    let noFileVal = "No file chosen...";

    if (/^\s*$/.test(filename)) {
      classFileUpload = "file-upload";
      noFileVal = "No file chosen...";
    } else {
      classFileUpload = "file-upload active";
      noFileVal = filename.replace("C:\\fakepath\\", "");
    }

    this.setState({ classFileUpload, noFileVal }, () => {
      const dicFileToBeUpload = {};
      const listFileNameSelected = [];
      let totalFiles = 0;
      if (target.files) {
        for (let index in target.files) {
          if (new RegExp(/^\d+$/).test(index)) {
            const file = target.files[index];
            const totalCount =
              file.size % chunkSize === 0
                ? file.size / chunkSize
                : Math.floor(file.size / chunkSize) + 1; // Total count of chunks will have been upload to finish the file
            const fileID = uuidv4() + "." + file.name.split(".").pop();
            dicFileToBeUpload[file.name] = {
              counter: 1,
              fileName: file.name,
              fileToBeUpload: file,
              beginingOfTheChunk: 0,
              endOfTheChunk: chunkSize,
              fileGuid: fileID,
              fileSize: file.size,
              chunkCount: totalCount > 0 ? totalCount : 1,
              isUploaded: false,
            };
            listFileNameSelected.push(file.name);
            totalFiles++;
          }
        }
        if (totalFiles === 1) {
          noFileVal = listFileNameSelected[0];
          classFileUpload = "file-upload active";
        }
        if (totalFiles > 1) {
          noFileVal = `${totalFiles} files chosen`;
        }
      }
      this.setState({
        classFileUpload,
        listFileNameSelected,
        dicFileToBeUpload,
        noFileVal,
        totalFiles,
      });
    });
  };

  onDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    this.setState({ isDragging: false });
    if (this.state.progressValue > 0) return;
    const files = e.dataTransfer ? e.dataTransfer.files : null;
    this.onChangeFile({ target: { files, value: "dropped" } });
  };

  getCurrentFileUploadingInfo = () => {
    const { fileUploading, dicFileToBeUpload } = this.state;
    const fileUploadingInfo = dicFileToBeUpload.hasOwnProperty(fileUploading)
      ? dicFileToBeUpload[fileUploading]
      : {};
    return fileUploadingInfo;
  };

  updateDicFileToBeUpload = (fileName, data, cb) => {
    const dicFileToBeUpload = this.state.dicFileToBeUpload;
    if (dicFileToBeUpload.hasOwnProperty(fileName)) {
      dicFileToBeUpload[fileName] = { ...dicFileToBeUpload[fileName], data };
    }
    this.setState({ dicFileToBeUpload }, () => {
      cb && cb();
    });
  };

  onUploadChunkFile = () => {
    try {
      let fileUploadingInfo = this.getCurrentFileUploadingInfo();
      const fileUploading = this.state.fileUploading;
      const currentCounter = fileUploadingInfo.counter;
      fileUploadingInfo["counter"] = currentCounter + 1;

      this.updateDicFileToBeUpload(
        fileUploading,
        fileUploadingInfo,
        async () => {
          fileUploadingInfo = this.getCurrentFileUploadingInfo();
          const {
            fileGuid,
            chunkCount,
            fileToBeUpload,
            beginingOfTheChunk,
            endOfTheChunk,
          } = fileUploadingInfo;

          if (currentCounter <= chunkCount) {
            const chunk = fileToBeUpload.slice(
              beginingOfTheChunk,
              endOfTheChunk,
            );

            Http.uploadChuckFile(chunk, {
              id: currentCounter,
              fileName: fileGuid,
            }).then(async (response) => {
              const isSuccess = response ? response.Success : false;
              if (isSuccess) {
                fileUploadingInfo["beginingOfTheChunk"] = endOfTheChunk;
                fileUploadingInfo["endOfTheChunk"] = endOfTheChunk + chunkSize;
                this.updateDicFileToBeUpload(
                  fileUploading,
                  fileUploadingInfo,
                  async () => {
                    fileUploadingInfo = this.getCurrentFileUploadingInfo();
                    if (currentCounter == chunkCount) {
                      fileUploadingInfo["isUploaded"] = true;
                      this.updateDicFileToBeUpload(
                        fileUploading,
                        fileUploadingInfo,
                        async () => {
                          let isAllFilesUploaded = true;
                          for (let fileName in this.state.dicFileToBeUpload) {
                            if (
                              this.state.dicFileToBeUpload[fileName][
                                "isUploaded"
                              ] === false
                            ) {
                              isAllFilesUploaded = false;
                              break;
                            }
                          }
                          console.warn(
                            `The file upload is completed. Counter: ${currentCounter}, OriginFile: ${fileToBeUpload.name}, FileId: ${fileGuid}`,
                          );
                          await this.onUploadChunkFileComplete(
                            isAllFilesUploaded,
                          );
                        },
                      );
                    } else {
                      var percentage =
                        this.state.progressValue /
                          Object.keys(this.state.dicFileToBeUpload).length +
                        (currentCounter / chunkCount) * 100;
                      if (percentage > 99) percentage = 100;
                      console.warn(
                        `'The file is uploading. Counter ${currentCounter}, OriginFile: ${fileToBeUpload.name}, FileId: ${fileGuid}`,
                      );
                      this.setState({ progressValue: percentage }, () => {
                        this.onUploadChunkFile();
                      });
                    }
                  },
                );
              } else {
                await this.handleUploadFileResponse(response);
              }
            });
          }
        },
      );
    } catch (error) {
      console.error(error);
    }
  };

  onUploadChunkFileComplete = async (isAllFilesUploaded) => {
    const {
      reportName,
      reportDate,
      fileExtension,
      isUploadAndMerge,
      isUploadOnly,
      isCalculateOnly,
      singleConsol,
    } = this.state;
    let fileUploadingInfo = this.getCurrentFileUploadingInfo();
    const { fileToBeUpload, fileGuid } = fileUploadingInfo;

    Http.uploadChuckFileComplete(
      fileGuid,
      {
        originFileName: fileToBeUpload ? fileToBeUpload.name : fileGuid,
        fileGuid: fileGuid,
        reportName: convertReportName(reportName),
        reportDate: reportDate,
        isAllFilesUploaded,
        fileExtension,
        singleConsol,

        isUploadOnly: isUploadOnly.toString(),
        isUploadAndMerge: isUploadAndMerge.toString(),
        isCalculateOnly: isCalculateOnly.toString(),
      },
      Business.COMPONENT.RAROC,
    ).then((res) => {
      if (res && res.ErrorCode == ErrorCode.PendingUpload) {
        let { listFileNameSelected } = this.state;
        const fileUploading = listFileNameSelected.shift();
        this.setState({ fileUploading, listFileNameSelected }, () => {
          this.onUploadChunkFile();
        });
      } else {
        this.setState({ progressValue: 100 }, () => {
          this.handleUploadFileResponse(res);
          this.onGetBatchUploadingResponse();
        });
      }
    });
  };

  onUploadFile = () => {
    this.setState(
      { hasResult: false, progressValue: 5, currentStep: "processing" },
      () => {
        if (this.state.isCalculateOnly) {
          this.onUploadChunkFileComplete(true);
          return;
        }
        let { listFileNameSelected } = this.state;
        const fileUploading = listFileNameSelected.shift();
        this.setState({ fileUploading, listFileNameSelected }, () => {
          this.onUploadChunkFile();
        });
      },
    );
  };

  onGetBatchUploadingResponse = () => {
    const intervalId = setInterval(() => {
      console.warn(
        `${convertReportName(this.state.reportName)} | Request to get batch response`,
      );
      Http.getBatchResult(
        this.state.reportDate,
        convertReportName(this.state.reportName),
      ).then((res) => {
        if (res) {
          if (res.ErrorCode === ErrorCode.PendingBatchProcessing) {
            console.warn(
              `${convertReportName(
                this.state.reportName,
              )} | Received state: PendingBatchProcessing`,
            );
          } else if (res.ErrorCode === ErrorCode.BatchEmpty) {
            clearGetBatchUploadInterval(
              convertReportName(this.state.reportName),
            );
            console.warn(
              `${convertReportName(this.state.reportName)} | Received state: BatchEmpty`,
            );
          } else {
            console.warn(
              `${convertReportName(this.state.reportName)} | Received state: Success`,
            );
            this.handleUploadFileResponse(res);
          }
        }
      });
    }, 3000);
    lstInterval.push(intervalId);
  };

  onValidate = () => {
    if (!this.state.fileExtension) {
      Business.showAlert({
        title: "Error",
        content: "You must choose a file extension before upload.",
      });
      return false;
    }
    if (this.state.totalFiles === 0) {
      Business.showAlert({
        title: "Error",
        content: "You must select least 1 file.",
      });
      return false;
    }

    if (!this.state.reportName) {
      Business.showAlert({
        title: "Error",
        content: "You must enter value for Report Name.",
      });
      return false;
    }

    if (!new RegExp("^[A-Za-z0-9_]+$").test(this.state.reportName)) {
      Business.showAlert({
        title: "Error",
        content: "Report Name: allow only (a-z, A-Z, 0-9, _)",
      });
      return false;
    }

    if (!this.state.reportDate) {
      Business.showAlert({
        title: "Error",
        content: "You must enter value for Report Date.",
      });
      return false;
    }
    return true;
  };

  onUploadFileOnly = () => {
    if (this.onValidate()) {
      this.setState({ isUploadOnly: true }, this.onUploadFile);
    }
  };

  onUploadFileAndMergeData = () => {
    if (this.onValidate()) {
      this.setState({ isUploadAndMerge: true }, this.onUploadFile);
    }
  };

  setFileExtensionSelected = (fileExtension) => {
    if (this.state.fileExtension != fileExtension) {
      this.setState({
        fileExtension,
        isMultipleFile: fileExtension != FileExtension.XLSX,
        fileAccept: `.${fileExtension}, ${this.fileAccept}`,
        file: null,
      });
    }
  };

  handleHideShowBtn(statusOfBatch) {
    if (statusOfBatch === Business.ENUMS.FILE_STATUS.REJECTED) {
      this.setState({
        isDisableRejectButton: true,
        isDisableApprovalButton: true,
        isDisableReasonInput: true,
        isDisableCalculateButton: true,
      });
    }
    if (
      statusOfBatch === Business.ENUMS.FILE_STATUS.APPROVED ||
      statusOfBatch === Business.ENUMS.FILE_STATUS.CALCULATION_STOPPED
    ) {
      this.setState({
        isDisableRejectButton: true,
        isDisableApprovalButton: true,
        isDisableReasonInput: true,
        isDisableCalculateButton: false,
      });
    }
    if (statusOfBatch === Business.ENUMS.FILE_STATUS.CALCULATING) {
      this.setState({
        isDisableRejectButton: true,
        isDisableApprovalButton: true,
        isDisableReasonInput: true,
        isDisableCalculateButton: true,
      });
    }
  }

  handleErrorCode(res) {
    this.handleHideShowBtn(Business.ENUMS.FILE_STATUS.CALCULATION_STOPPED);
    this.setState({
      status: Business.convertFileStatus(
        Business.ENUMS.FILE_STATUS.CALCULATION_STOPPED,
      ),
    });
    if (res) {
      switch (res.ErrorCode) {
        case ErrorCode.PermissionDenie:
          Business.showAlert({
            title: "Error",
            content: "You are not permission",
          });
          break;
        case ErrorCode.Empty:
          Business.showAlert({ title: "Error", content: "File is empty" });
          break;
        case ErrorCode.Exist:
          Business.showAlert({
            title: "Error",
            content: "Name already exists in the system",
          });
          break;
        case ErrorCode.DataInvalid:
          Business.showAlert({
            title: "Error",
            content: res.Data || "System Error",
          });
          break;
        case ErrorCode.UnknowError:
          Business.showAlert({
            title: "Error",
            content: res.Data || "System Error",
          });
          break;
        default:
          break;
      }
    } else {
      Business.showAlert({ title: "Error", content: "Unknow Error" });
    }
  }

  handleCalculateResponse = (res) => {
    const errorCode = res ? res.ErrorCode : null;
    this.setState({ errorCode });
    if (res && res.Success) {
      const data = res.Data || {};
      this.setState({
        hasResult: true,
        singleResult: data.SingleResult,
        consolResult: data.ConsolResult,
      });
    } else {
      this.handleErrorCode(res);
    }
  };

  handleGetBatchUploadingResponse = (res) => {
    if (res) {
      if (res.ErrorCode === ErrorCode.PendingBatchProcessing) {
        console.warn(
          `${this.state.reportName} | Received state: PendingBatchProcessing`,
        );
      } else {
        console.warn(`${this.state.reportName} | Received state: Success`);
        const errorCode = res ? res.ErrorCode : null;
        this.setState({ errorCode });
        if (res && res.ErrorCode !== ErrorCode.PendingBatchProcessing) {
          clearGetBatchUploadInterval(convertReportName(this.state.reportName));
        }
        if (res && res.Success) {
          if (res.ErrorCode === ErrorCode.PendingBatchProcessing) {
            // console.warn('Received state: PendingBatchProcessing');
          } else if (res.ErrorCode === ErrorCode.BatchEmpty) {
            clearGetBatchUploadInterval(
              convertReportName(this.state.reportName),
            );
            console.warn("Received state: BatchEmpty");
          } else {
            this.handleCalculateResponse(res);
          }
        } else {
          this.handleErrorCode(res);
        }
      }
    }
  };

  onGetBatchResponse = () => {
    const intervalId = setInterval(() => {
      console.warn(`${this.state.reportName} | Request to get batch response`);
      Http.getBatchResult(
        this.state.reportDate,
        convertReportName(this.state.reportName),
      ).then((res) => {
        this.handleGetBatchUploadingResponse(res);
      });
    }, 3000);
    lstInterval.push(intervalId);
  };

  handleUploadFileResponse = (res) => {
    const errorCode = res ? res.ErrorCode : null;
    this.setState({ errorCode });
    if (res && res.ErrorCode !== ErrorCode.PendingBatchProcessing) {
      clearGetBatchUploadInterval(convertReportName(this.state.reportName));
      this.setState({
        loading: true,
        errorCode: ErrorCode.PendingBatchProcessing,
        status: Business.convertFileStatus(
          Business.ENUMS.FILE_STATUS.CALCULATING,
        ),
      });
    }
    if (res && res.Success) {
      let isAllowCalculate = false;
      if (res.ErrorCode === ErrorCode.PendingBatchProcessing) {
        // console.warn('Received state: PendingBatchProcessing');
      } else if (res.ErrorCode === ErrorCode.BatchEmpty) {
        // console.warn('Received state: BatchEmpty');
      } else if (res.ErrorCode === ErrorCode.UploadOnlySuccessful) {
        isAllowCalculate = true;
        this.setState(
          {
            progressValue: 0,
            isUploadOnly: false,
            isUploadAndMerge: false,
            isCalculateOnly: false,
            isUploadOnlySuccessful: true,
            isUploadAndMergeSuccessful: false,
            validatePageUrl: buildValidatePageUrl(
              this.state.reportDate,
              convertReportName(this.state.reportName),
            ),
          },
          () => this.startSseValidation(),
        );
      } else if (res.ErrorCode === ErrorCode.UploadAndMergeSuccessful) {
        isAllowCalculate = true;
        this.setState(
          {
            progressValue: 0,
            isUploadOnly: false,
            isUploadAndMerge: false,
            isCalculateOnly: false,
            isUploadOnlySuccessful: false,
            isUploadAndMergeSuccessful: true,
            validatePageUrl: buildValidatePageUrl(
              this.state.reportDate,
              convertReportName(this.state.reportName),
            ),
          },
          () => this.startSseValidation(),
        );
      } else {
        const data = res.Data || {};
        this.setState({
          singleResult: data.SingleResult,
          consolResult: data.ConsolResult,
          progressValue: 0,
          hasResult: true,
          isUploadOnly: false,
          isUploadAndMerge: false,
          isCalculateOnly: false,
          isUploadOnlySuccessful: false,
          isUploadAndMergeSuccessful: false,
        });
      }

      if (isAllowCalculate) {
        Http.calculate(
          this.state.reportDate,
          convertReportName(this.state.reportName),
          null,
          null,
          this.state.option,
          Business.COMPONENT.RAROC,
        ).then((res) => {
          this.setState({ loading: false });
          if (res && res.ErrorCode === ErrorCode.PendingBatchProcessing) {
            this.onGetBatchResponse();
          } else {
            this.handleCalculateResponse(res);
          }
        });
      }
    } else {
      if (res) {
        switch (res.ErrorCode) {
          case ErrorCode.PermissionDenie:
            Business.showAlert({
              title: "Error",
              content: "You are not permission",
            });
            break;
          case ErrorCode.Empty:
            Business.showAlert({
              title: "Error",
              content: "File is empty",
            });
            break;
          case ErrorCode.Exist:
            Business.showAlert({
              title: "Error",
              content: "Name already exists in the system",
            });
            break;
          case ErrorCode.DataInvalid:
            Business.showAlert({
              title: "Error",
              content: res.Data,
            });
            break;
          case ErrorCode.FileInvalid:
            this.setState({
              uploadErrors: res.Data || [],
              validatePageUrl: buildValidatePageUrl(
                this.state.reportDate,
                convertReportName(this.state.reportName),
              ),
              sseDone: true,
            });
            break;
          case ErrorCode.UnknowError:
            Business.showAlert({
              title: "Error",
              content: res.Data || "System Error",
            });
            break;
          default:
            break;
        }
      } else {
        Business.showAlert({
          title: "Error",
          content: "Unknow Error",
        });
      }
      this.setState({
        progressValue: 0,
        errorCode: res.ErrorCode,
        isUploadOnly: false,
        isUploadAndMerge: false,
        isCalculateOnly: false,
        isUploadOnlySuccessful: false,
        isUploadAndMergeSuccessful: false,
      });
    }
  };

  renderPendingBatchProcessing = () => {
    return (
      <div>
        <div className="header">
          <h4
            style={{
              width: "100%",
              textAlign: "center",
              paddingBottom: "50px",
            }}
            className="title"
          >
            The system is processing the uploaded file. Please wait...
          </h4>
        </div>
      </div>
    );
  };

  renderProgress = () => {
    return (
      <div>
        <div className="row">
          <div className="col-xs-12">
            <div className="content text-center">
              <ProgressBar
                striped
                now={this.state.progressValue}
                label={`Upload ${this.state.progressValue.toFixed(3)}%`}
              />
            </div>
          </div>
        </div>
      </div>
    );
  };

  renderUploadOnlySuccessful = () => {
    return (
      <div>
        <div className="header">
          <h4
            style={{
              width: "100%",
              textAlign: "center",
              paddingBottom: "20px",
            }}
            className="title"
          >
            Upload successful
          </h4>
        </div>
        {this.state.validatePageUrl && (
          <div style={{ textAlign: "center", paddingBottom: "30px" }}>
            <button
              onClick={() =>
                this.props.history.push(this.state.validatePageUrl)
              }
              className="btn btn-primary"
              style={{
                backgroundColor: "#FFE600",
                borderColor: "#7F7E82",
                borderRadius: "5px",
                fontWeight: 600,
                color: "#000",
              }}
            >
              Xem kết quả kiểm tra
            </button>
          </div>
        )}
      </div>
    );
  };

  renderUploadAndMegeSuccessful = () => {
    return (
      <div>
        <div className="header">
          <h4
            style={{
              width: "100%",
              textAlign: "center",
              paddingBottom: "20px",
            }}
            className="title"
          >
            Upload and merge data successfully
          </h4>
        </div>
        {this.state.validatePageUrl && (
          <div style={{ textAlign: "center", paddingBottom: "30px" }}>
            <button
              onClick={() =>
                this.props.history.push(this.state.validatePageUrl)
              }
              className="btn btn-primary"
              style={{
                backgroundColor: "#FFE600",
                borderColor: "#7F7E82",
                borderRadius: "5px",
                fontWeight: 600,
                color: "#000",
              }}
            >
              Xem kết quả kiểm tra
            </button>
          </div>
        )}
      </div>
    );
  };

  handleSelectSingleConsolMethod = (eventKey, event) => {
    this.setState({ singleConsol: eventKey });
  };

  onShowMessageBox = (lstErrUpload) => {
    this.setState({
      isShowMessageBox: true,
      lstErrUpload: lstErrUpload,
    });
  };

  onCloseMessageBox = () => {
    this.setState({
      isShowMessageBox: false,
      lstErrUpload: [],
    });
  };

  startSseValidation = () => {
    const { reportDate, reportName } = this.state;
    if (!reportDate || !reportName) return;
    if (this._sseSource) {
      this._sseSource.close();
      this._sseSource = null;
    }
    this.setState({
      sseErrors: [],
      ssePercent: 0,
      sseDone: false,
      sseStarted: false,
    });
    const token = Http.getToken() || "";
    const url = `${ApiURL.fileV2}/validate-data-stream?reportDate=${encodeURIComponent(reportDate)}&reportName=${encodeURIComponent(convertReportName(reportName))}&component=RAROC&jwt=${encodeURIComponent(token)}`;
    const es = new EventSource(url);
    this._sseSource = es;
    es.addEventListener("start", () => {
      this.setState({ sseStarted: true });
    });
    es.addEventListener("progress", (e) => {
      this.setState({ ssePercent: JSON.parse(e.data).percent || 0 });
    });
    es.addEventListener("file", (e) => {
      const d = JSON.parse(e.data);
      if (d.errorCount > 0)
        this.setState((p) => ({ sseErrors: [...p.sseErrors, d] }));
    });
    es.addEventListener("done", () => {
      this.setState({ sseDone: true, ssePercent: 100 });
      es.close();
      this._sseSource = null;
    });
    es.onerror = () => {
      this.setState({ sseDone: true });
      es.close();
      this._sseSource = null;
    };
  };

  renderProcessingStep = () => {
    const {
      progressValue,
      ssePercent,
      sseDone,
      sseErrors,
      sseStarted,
      uploadErrors,
      errorCode,
    } = this.state;
    const totalSseErrors = sseErrors.reduce((s, f) => s + f.errorCount, 0);
    return (
      <div>
        <div className="header">
          <h4 className="title">
            <button
              type="button"
              className="btn btn-default btn-xs"
              style={{ marginRight: 12 }}
              onClick={() => {
                if (this._sseSource) {
                  this._sseSource.close();
                  this._sseSource = null;
                }
                this.setState({ currentStep: "form" });
              }}
            >
              ← Quay lại
            </button>
            Kết quả kiểm tra dữ liệu
          </h4>
        </div>
        <div className="content">
          {progressValue > 0 && progressValue < 100 && (
            <div style={{ marginBottom: 16 }}>
              <ProgressBar
                striped
                now={progressValue}
                label={`Đang upload ${progressValue.toFixed(1)}%`}
              />
            </div>
          )}
          {errorCode === ErrorCode.PendingBatchProcessing && !sseStarted && (
            <p style={{ textAlign: "center", color: "#888" }}>
              Hệ thống đang xử lý dữ liệu, vui lòng chờ...
            </p>
          )}
          {sseDone &&
            sseErrors.length === 0 &&
            uploadErrors.length === 0 &&
            errorCode === ErrorCode.PendingBatchProcessing && (
              <p style={{ textAlign: "center", color: "#888", marginTop: 8 }}>
                Hệ thống đang tính toán dữ liệu, vui lòng chờ...
              </p>
            )}
          {sseDone &&
            sseErrors.length === 0 &&
            uploadErrors.length === 0 &&
            this.state.hasResult && (
              <div style={{ textAlign: "center", marginTop: 8 }}>
                <p style={{ color: "green", fontWeight: 600 }}>
                  ✓ Xử lý hoàn tất
                </p>
                {this.state.validatePageUrl && (
                  <div>
                    {this.state.autoNavCountdown !== null && (
                      <p
                        style={{ color: "#888", fontSize: 13, marginBottom: 8 }}
                      >
                        Tự động chuyển trang sau {this.state.autoNavCountdown}
                        s...
                      </p>
                    )}
                    <button
                      onClick={() =>
                        this.props.history.push(this.state.validatePageUrl)
                      }
                      className="btn btn-primary"
                      style={{
                        backgroundColor: "#FFE600",
                        borderColor: "#7F7E82",
                        borderRadius: "5px",
                        fontWeight: 600,
                        color: "#000",
                      }}
                    >
                      Xem kết quả kiểm tra
                    </button>
                  </div>
                )}
              </div>
            )}
          {sseStarted && !sseDone && (
            <div style={{ marginBottom: 12 }}>
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <span>Tiến độ kiểm tra: {ssePercent}%</span>
              </div>
              <ProgressBar striped now={ssePercent} label={`${ssePercent}%`} />
            </div>
          )}
          {uploadErrors.length > 0 && (
            <div style={{ marginTop: 12 }}>
              <h5 style={{ color: "#c00" }}>
                Lỗi dữ liệu upload: {uploadErrors.length} lỗi
              </h5>
              <div style={{ maxHeight: 320, overflowY: "auto" }}>
                <table
                  className="table table-bordered table-striped"
                  style={{ fontSize: 13 }}
                >
                  <thead>
                    <tr>
                      <th>No.</th>
                      <th>Table</th>
                      <th>Row</th>
                      <th>Column</th>
                      <th>Value</th>
                      <th>Mô tả</th>
                    </tr>
                  </thead>
                  <tbody>
                    {uploadErrors.map((e, i) => (
                      <tr key={i}>
                        <td>{i + 1}</td>
                        <td>{e.table}</td>
                        <td>{e.row}</td>
                        <td>{e.column}</td>
                        <td>{e.value}</td>
                        <td style={{ color: "#c00" }}>{e.reason}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}
          {sseErrors.length > 0 && (
            <div style={{ marginTop: 12 }}>
              <h5 style={{ color: "#c00" }}>
                Danh sách lỗi dữ liệu: {totalSseErrors} lỗi
              </h5>
              <div style={{ maxHeight: 350, overflowY: "auto" }}>
                <table
                  className="table table-bordered table-striped"
                  style={{ fontSize: 13 }}
                >
                  <thead>
                    <tr>
                      <th>File</th>
                      <th>Dòng</th>
                      <th>Cột</th>
                      <th>Giá trị</th>
                      <th>Mô tả lỗi</th>
                    </tr>
                  </thead>
                  <tbody>
                    {sseErrors.map((f) =>
                      f.errors.map((e, i) => (
                        <tr key={`${f.fileName}-${i}`}>
                          {i === 0 && (
                            <td
                              rowSpan={f.errors.length}
                              style={{
                                fontWeight: 600,
                                verticalAlign: "middle",
                              }}
                            >
                              {f.fileName}
                            </td>
                          )}
                          <td>{e.row}</td>
                          <td>{e.column}</td>
                          <td>{e.value}</td>
                          <td style={{ color: "#c00" }}>{e.reason}</td>
                        </tr>
                      )),
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          )}
          {sseDone && sseErrors.length === 0 && uploadErrors.length === 0 && (
            <p
              style={{
                color: "green",
                textAlign: "center",
                fontWeight: 600,
                marginTop: 16,
              }}
            >
              ✓ Không phát hiện lỗi dữ liệu
            </p>
          )}
        </div>
      </div>
    );
  };

  renderMessageBox = () => {
    return (
      <MessageBox
        lstMsg={this.state.lstErrUpload}
        isShowMessageBox={this.state.isShowMessageBox}
        onCloseMessageBox={this.onCloseMessageBox}
      />
    );
  };

  render() {
    return (
      Business.isHasRole([Business.ROLE_DEFINE_MAP.ICAAP_UPLOAD_FILES]) && (
        <div className="card upload-form-animated">
          {this.state.currentStep === "processing" ? (
            this.renderProcessingStep()
          ) : (
            <div>
              <div className="header">
                <h4 className="title">Upload file</h4>
              </div>
              <div style={{ height: 15 }} />
              <div
                className="content"
                style={{ paddingBottom: "0px !important" }}
              >
                <div className="upload-two-col">
                  <div className="upload-two-col__left">
                    <form>
                      <div className="form-group row">
                        <div className="col-md-6">
                          <div className="file-type-tabs">
                            {Object.keys(FileExtension).map(
                              (fileExtension, index) => (
                                <button
                                  key={index}
                                  type="button"
                                  className={
                                    "file-tab-item" +
                                    (this.state.fileExtension === fileExtension
                                      ? " active"
                                      : "")
                                  }
                                  onClick={() =>
                                    this.setFileExtensionSelected(fileExtension)
                                  }
                                >
                                  .{fileExtension.toLowerCase()}
                                </button>
                              ),
                            )}
                          </div>
                        </div>
                        <div
                          className="col-md-6"
                          style={{ textAlign: "right", padding: "10px" }}
                        >
                          {/* <label>Ngày 31/12/2022 đang tồn tại bản ghi Chờ phê duyệt</label> */}
                        </div>
                      </div>
                      <div className="form-group">
                        <label htmlFor="exampleFormControlFile1">
                          Data file
                        </label>
                        <div
                          onDragOver={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            if (this.state.progressValue === 0) {
                              this.setState({ isDragging: true });
                            }
                          }}
                          onDragEnter={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            if (this.state.progressValue === 0) {
                              this.setState({ isDragging: true });
                            }
                          }}
                          onDragLeave={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            this.setState({ isDragging: false });
                          }}
                          onDrop={this.onDrop}
                          onClick={() => {
                            if (this.state.progressValue === 0) {
                              document.getElementById("chooseFile").click();
                            }
                          }}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            border: this.state.isDragging
                              ? "2px dashed #FFE600"
                              : "1px dashed #bbb",
                            borderRadius: 8,
                            padding: "10px 14px",
                            background: this.state.isDragging
                              ? "#fffef0"
                              : "#fafafa",
                            gap: 10,
                            cursor:
                              this.state.progressValue > 0
                                ? "not-allowed"
                                : "pointer",
                            transition: "border 0.15s, background 0.15s",
                          }}
                        >
                          <i
                            className="pe-7s-upload"
                            style={{
                              fontSize: 22,
                              color: this.state.isDragging
                                ? "#FFE600"
                                : "#1a1a3e",
                              transition: "color 0.15s",
                            }}
                          />
                          <div style={{ flex: 1 }}>
                            <div
                              style={{
                                fontSize: 13,
                                color:
                                  this.state.noFileVal === "No file chosen..."
                                    ? "#aaa"
                                    : "#1E1E1E",
                                fontWeight:
                                  this.state.noFileVal === "No file chosen..."
                                    ? 400
                                    : 600,
                              }}
                            >
                              {this.state.isDragging
                                ? "Thả file vào đây..."
                                : this.state.noFileVal}
                            </div>
                            <div
                              style={{
                                fontSize: 11,
                                color: "#888",
                                marginTop: 2,
                              }}
                            >
                              {this.state.fileExtension === FileExtension.CSV
                                ? "Kéo thả hoặc click để chọn nhiều file CSV (Ctrl+A để chọn tất cả)"
                                : "Kéo thả hoặc click để chọn file"}
                            </div>
                          </div>
                          <label
                            htmlFor="chooseFile"
                            onClick={(e) => e.stopPropagation()}
                            style={{
                              margin: 0,
                              padding: "6px 14px",
                              borderRadius: 6,
                              background:
                                this.state.progressValue > 0
                                  ? "#eee"
                                  : "#FFE600",
                              color:
                                this.state.progressValue > 0
                                  ? "#aaa"
                                  : "#1a1a3e",
                              fontSize: 12,
                              fontWeight: 600,
                              cursor:
                                this.state.progressValue > 0
                                  ? "not-allowed"
                                  : "pointer",
                              whiteSpace: "nowrap",
                            }}
                          >
                            Chọn file
                          </label>
                          <input
                            type="file"
                            multiple={this.state.isMultipleFile}
                            name="chooseFile"
                            id="chooseFile"
                            disabled={this.state.progressValue > 0}
                            accept={this.state.fileAccept}
                            onChange={(e) => this.onChangeFile(e)}
                            style={{ display: "none" }}
                          />
                        </div>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <div className="form-group" style={{ width: "80%" }}>
                          <label htmlFor="exampleInputEmail1">
                            Report Name
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="reportname"
                            onChange={(event) => {
                              this.setState({ reportName: event.target.value });
                            }}
                          />
                        </div>
                        <div className="form-group" style={{ width: "18%" }}>
                          <label htmlFor="exampleInputEmail12">
                            Report Date
                          </label>
                          <input
                            type="date"
                            className="form-control"
                            id="reportDate"
                            min="2010-01-01"
                            max={moment(new Date(), "YYYY-MM-DD").format(
                              "YYYY-MM-DD",
                            )}
                            placeholder="MM/DD/YYYY"
                            value={this.state.reportDate}
                            onChange={(event) => {
                              this.setState({ reportDate: event.target.value });
                            }}
                          />
                        </div>
                      </div>
                      <div>
                        <Options
                          onChangeOption={(value) => {
                            this.setState({ option: value });
                          }}
                        />
                      </div>
                    </form>
                  </div>
                  <div className="upload-two-col__right">
                    <UploadSelectedFilesPanel
                      selectedFiles={this.state.listFileNameSelected}
                    />
                  </div>
                </div>
              </div>
              <div className="content table-full-width">
                <div style={{ display: "inline" }}>
                  <button
                    type="button"
                    disabled={this.state.progressValue > 0}
                    className="btn btn-primary"
                    style={{
                      backgroundColor: "#FFE600",
                      borderColor: "#7F7E82",
                      borderRadius: "5px",
                      fontWeight: 600,
                      marginLeft: "auto",
                      float: "left",
                    }}
                    onClick={() => this.onUploadFileOnly()}
                  >
                    Upload
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      )
    );
  }
}

export default reduxForm({
  form: "UploadFile",
})(UploadFile);



// WEBPACK FOOTER //
// src/pages/Raroc/UploadFile/index.js